import FileCopyIcon from '@mui/icons-material/FileCopy';

const icons = {
    FileCopyIcon
};

const UnListedClient = {
    id: 'Unlisted_Clients_calims',
    type: 'group',
    children: [
        {
            id: 'Unlisted_Clients_calims1',
            title: 'Unlisted Clients',
            type: 'item',
            url: '/unlisted_Clients_calims',
            icon: icons.FileCopyIcon,
        }
    ]
};

export default UnListedClient;